/**
 * Lib.Common: Preinitialization
 */


if (typeof $util !== 'undefined') {
    throw new Error('Attempted to load Lib.Common more than once in the same context; aborting');
}


const el = document.createElement('div');
const havePaddingDir = 'marginBlockEnd' in el.style || 'webkitMarginEnd' in el.style;
const haveBorderDir = 'borderBlockEnd' in el.style;
let minScrollbarWidth;
let minScrollbarHeight;

let i = 0;
const style = document.createElement('style');
style.appendChild(document.createTextNode(''));
document.head.appendChild(style);

const insert = function(cls, props) {
    style.sheet.insertRule('[dir=ltr] .' + cls + ',[dir=rtl] [dir=ltr] .' + cls + '{' + props.replace(/S/g,'left').replace(/E/g,'right') + '}', i++);
    style.sheet.insertRule('[dir=rtl] .' + cls + ',[dir=ltr] [dir=rtl] .' + cls + '{' + props.replace(/E/g,'left').replace(/S/g,'right') + '}', i++);
};

if (!havePaddingDir) {
    const sizes = [0,1,2,4,6,8,12,16,24,32,64];
    sizes.forEach(size => {
        insert('start-' + size, 'padding-S:' + size + 'px');
        insert('end-' + size, 'padding-E:' + size + 'px');
    });
}

if (!haveBorderDir) {
    insert('border-start', 'border-S-width:1px;border-S-style:solid');
    insert('border-end', 'border-E-width:1px;border-E-style:solid');
}

function computeOnLoad() {
    const style = document.createElement('style');
    style.textContent =
        '._itest{' +
            'position:fixed;' +
            'text-align:end;' +
            'overflow:scroll;' +
            'width:64px;' +
            'height:64px;' +
            '-ms-overflow-style:none;' +
            'scrollbar-width:none;' +
        '}' +
        '._itest::-webkit-scrollbar{' +
            'display:none;' +
        '}';
    el.classList.add('_itest');
    document.head.appendChild(style);
    document.body.appendChild(el);
    minScrollbarWidth = el.offsetWidth - el.clientWidth;
    minScrollbarHeight = el.offsetHeight - el.clientHeight;
    const haveTextDir = getComputedStyle(el).getPropertyValue('text-align') == 'end';
    document.body.removeChild(el);
    document.head.removeChild(style);

    if (!haveTextDir) {
        insert('text-start', 'text-align:S');
        insert('text-end', 'text-align:E');
        insert('_tb th', 'text-align:S');
        insert('_fastart ._fldin', 'text-align:S');
        insert('_faend ._fldin', 'text-align:E');
    }
}

if (document.body) {
    computeOnLoad();
} else {
    addEventListener('DOMContentLoaded', computeOnLoad);
}


export {
    minScrollbarWidth,
    minScrollbarHeight
};
